import React from 'react';

export enum DisplayTypes {
  ErrorButton = 'error-button',
}

export type Option = {
  value: string;
  label: string;
  description?: string;
  start?: React.ReactNode;
  hasBottomSeparator?: boolean;
  children?: Option[];
  selectChildrenOnly?: boolean;
  displayType?: DisplayTypes;
};

export enum Size {
  ExtraSmall = 'extra-small',
  Small = 'small',
  Medium = 'medium',
}
